// extracted by mini-css-extract-plugin
export default {"root":"AlbumLabel__root--10qQd"};